const styles = (theme) => ({
  container: {
    width: '100%',
    position: 'relative',
    padding: theme.spacing(3.75, 0),
  },
  errorMessage: {
    margin: theme.spacing(-4.5, -2.5, 2.5),
    padding: theme.spacing(2.5),
    background: theme.color.red,
    color: theme.color.white,
  },
  productWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  productImg: {
    marginRight: theme.spacing(3),
    width: 100,

    '& img': {
      width: '100%',
    },
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    marginTop: theme.spacing(-2.5),
    width: 24,
    height: 24,
    padding: 0,

    '& svg': {
      height: 16,
      width: 16,
    },
  },
  priceContainer: {
    lineHeight: 2.5,
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
  },
  price: {
    marginBottom: theme.spacing(0.5),
  },
  giftWrapText: {
    marginRight: theme.spacing(1),
    color: theme.color.grey_8A,
    '& span': {
      margin: theme.spacing(0, 0, 2),
    },
  },
  giftWrapIcon: {
    transform: 'translate(0, 8px)',
    fill: theme.color.grey_dark,
    marginRight: theme.spacing(1),
  },
});

export default styles;
